import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";

interface IProps {
	takeawayFee: number;
}

const PaymentDetailTakeawayItem = ({ takeawayFee }: IProps): ReactElement => {
	const { t } = useTranslation();

	return (
		<li className="CartItem CartTakeawayItem">
			<div className="ItemHeader">
				<div className="ItemName">
					<span className="ItemNameText">{t("orderConfirmation.takeawayBag")}</span>
				</div>
				<div className="ItemHeaderRight">
					<span className="Price TabularNums">{`$${centsToDollarsDisplay(takeawayFee)}`}</span>
				</div>
			</div>
		</li>
	);
};

export default PaymentDetailTakeawayItem;
